@use 'styles/colors' as *;
@use 'styles/functions/rem' as *;

.informationNotification {
    background-color: $informationNotificationBackgroundColor;
    height: rem(46px);
}
